// src/app/services/openingApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IOpening, IOpeningParams, UpdatePayload } from '../models';

export const openingApi = createApi({
  reducerPath: 'openingApi',
  baseQuery,
  endpoints: (builder) => ({
    getOpeningParams: builder.query<{ opening: IOpeningParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/opening/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
      transformResponse: (data: { opening: IOpeningParams }) => {
        data.opening.mounting_plane = data.opening.mounting_plane.filter(
          (el) => el.id < 7
        );
        return data;
      },
    }),
    getOpening: builder.query<IOpening, number>({
      query: (id) => `/api/v1.0/ahu/openings/${id}`,
    }),

    updateOpening: builder.mutation<IOpening, UpdatePayload<IOpening>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/openings/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
    createOpening: builder.mutation<any, UpdatePayload<any>>({
      query: ({ body, signal }) => ({
        url: `/api/v1.0/ahu/openings/`,
        method: 'POST',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetOpeningQuery,
  useGetOpeningParamsQuery,
  useUpdateOpeningMutation,
  useCreateOpeningMutation,
} = openingApi;

// Opening API service - helpers moved to apiHelpers.ts